/// <amd-module name="typeahead/features/LXCategorySuggestion" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {ClientHandlerRegistry} from "typeahead/client/ClientHandlerRegistry";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult, IExtraSearchParam} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage"],
        tabs: ["activity"],
    },
    {
        clients: ["LXLandingPage"],
    },
];

const featureFlag = "lxcategory";

export class LXCategorySuggestion implements IRequestUrlParamModifier, ISuggestionsModifier, IPageLoadHandler {

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
    JQueryPromise<ISuggestServiceQueryParams> {
        context.tab = ClientHandlerRegistry.getTab();
        return addFeatureFlag(featureFlag, configuration, params, context, options);
    }

    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any):
    JQueryPromise<Object[]> {
        let deferred: JQueryDeferred<Object[]> = $.Deferred();
        if (suggestions && suggestions.length > 0) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    if (shouldExecute) {
                        suggestions.forEach((suggestion: IEssSuggestionResult): void => {
                            if (suggestion.hierarchyInfo) {
                                let relation = suggestion.hierarchyInfo.relation;
                                if (relation && relation[0] === "lxcategory") {
                                    suggestion.showAsHierarchy = true;
                                }
                            }
                        });
                    }
                })
                .always(() => {
                    deferred.resolve(suggestions);
                });
        } else {
            deferred.resolve(suggestions);
        }
        return deferred.promise();
    }

    public handlePageLoad(options: any, context: IContext): JQueryPromise<undefined> {
        let deferred: JQueryDeferred<undefined> = $.Deferred();
        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, suggestion: SuggestionSelectedMessage) => {
                context.tab = ClientHandlerRegistry.getTab();
                ExecutionHelper.shouldExecute(context, configuration)
                    .done((shouldExecute: boolean): void => {
                        if (shouldExecute) {
                            let params: Optional<IExtraSearchParam[]> =
                                suggestion.getSuggestion().getExtraSearchParams();
                            params.orElse([]).forEach((param: IExtraSearchParam) => {
                               let element = document.createElement("INPUT");
                               element.setAttribute("type", "hidden");
                               element.setAttribute("class", "uta-search-parameter");
                               element.setAttribute("name", param.field);
                               element.setAttribute("value", param.value);
                               $("div.tabs-container").find("form:visible").append(element);
                            });
                        }
                    })
                    .always((): void => {
                        deferred.resolve();
                    });
            });
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(),
            (topic: string) => {
                ExecutionHelper.shouldExecute(context, configuration)
                    .done((shouldExecute: boolean): void => {
                        if (shouldExecute) {
                            $("input.uta-search-parameter").remove();
                        }
                    });
            });

        return deferred.promise();
    }

}
